<h1 class="font-bold text-gray-950 text-2xl"><ng-content></ng-content></h1>
